import * as React from 'react';

import { CartServiceProps } from '../../types';
import { ServiceSummary } from '../../../features/service-summary';

const TransferExtraCart: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<ServiceSummary serviceType="Transfer" onDelete={onServiceDelete}>
			{content => content && <span>{content}</span>}
		</ServiceSummary>
	);
};

export default TransferExtraCart;
